var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.521484,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.521484,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.3069 23.2146C30.7532 23.6609 30.7532 24.3856 30.3069 24.8319L23.452 31.6868C23.0057 32.1331 22.281 32.1331 21.8347 31.6868C21.3884 31.2405 21.3884 30.5157 21.8347 30.0695L27.8827 24.0215L21.8383 17.9735C21.392 17.5272 21.392 16.8025 21.8383 16.3562C22.2846 15.9099 23.0093 15.9099 23.4556 16.3562L30.3104 23.211L30.3069 23.2146Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow-right.5a43a9ff96063e3c3e667c2cd8ef1dce.svg";
export { ForwardRef as ReactComponent };